import React, { Suspense } from 'react';
import { Redirect, BrowserRouter as Router, Switch } from 'react-router-dom';

import ProgressBar from 'components/ProgressBar';
import Logout from 'components/logout';

import LoginPage from 'features/Auth/LoginPage';

import Default from 'layout/Default';

import AuthorizedRoute from 'routes/AuthorizedRoute';
import UnauthorizedRoute from 'routes/UnauthorizedRoute';

const Dashboard = React.lazy(() => import('features/Dashboard/DashboardPage'));
const ManualKycView = React.lazy(() => import('features/Kyc/ManualKycDashboard/ManualKycView'));
const ManualKYCAdmin = React.lazy(() => import('features/Kyc/ManualKycDashboard/ManualKycAdmin'));
const ManualKycDetails = React.lazy(() => import('features/Kyc/ManualKycDashboard/ManualKycView/Details/Sections'));

const Layout: React.FC = () => {
	return (
		<Suspense fallback={<ProgressBar loading />}>
			<Router basename={process.env.PUBLIC_URL}>
				<Default>
					<Switch>
						<AuthorizedRoute title="Logout" exact path="/logout" component={Logout} />
						<AuthorizedRoute title="Dashboard" exact path="/" component={Dashboard} />
						<AuthorizedRoute
							title="Manual KYC"
							exact
							path="/merchantkyc/manual-kyc"
							component={ManualKycView}
						/>
						<AuthorizedRoute
							title="KYC Detail"
							path="/merchantkyc/manual-kyc/details/:merchant_id/:kyc_type/:kyc_status/:kyc_source?/:stored_id?"
							component={ManualKycDetails}
						/>
						<AuthorizedRoute
							title="Manual KYC Admin"
							exact
							path="/merchantkyc/manual-kyc/admin"
							component={ManualKYCAdmin}
						/>
						<UnauthorizedRoute exact path="/login" component={LoginPage} />
						<Redirect to="/" />
					</Switch>
				</Default>
			</Router>
		</Suspense>
	);
};

export default React.memo(Layout);
